module.exports = __webpack_public_path__ + "static/ueberMich_bw-8f4d3862216f8f9c5c39c76f49d1f5f1.jpg";